import { FC, useEffect, useState } from "react";

import { CatchARideAvailabilityItemDisplay } from "./catch-a-ride-availability-item.display";
import { CatchARideAvailabilityItemEdit } from "./catch-a-ride-availability-item.edit";
import { ICatchARideAvailabilityItemForm } from "./catch-a-ride-availability.models";
import { useRestoreFocus } from "./use-restore-focus";

export const CatchARideAvailabilityItem: FC<
  ICatchARideAvailabilityItemForm
> = ({
  fieldName,
  index,
  value,
  setValueOuter,
  removeHandler,
  disabledEdit,
  disabledRemove,
  onEditStart,
  onEditEnd,
}) => {
  const [inEdit, setInEdit] = useState(false);
  const displayRef = useRestoreFocus<HTMLDivElement>(inEdit, ".edit-button");

  useEffect(() => {
    if (inEdit) {
      onEditStart?.();
    } else {
      onEditEnd?.();
    }
  }, [inEdit, onEditStart, onEditEnd]);

  if (inEdit) {
    return (
      <CatchARideAvailabilityItemEdit
        fieldName={fieldName}
        setValueOuter={setValueOuter}
        index={index}
        value={value}
        onCancelOuter={() => setInEdit(false)}
      />
    );
  }

  return (
    <div ref={displayRef}>
      <CatchARideAvailabilityItemDisplay
        fieldName={fieldName}
        index={index}
        value={value}
        removeHandler={removeHandler}
        onEdit={() => setInEdit(true)}
        disabledEdit={disabledEdit}
        disabledRemove={disabledRemove}
      />
    </div>
  );
};
